import Head from "next/head";
import { organizationMicroData } from "./meta-utils";

function OrganizationMetaHeader() {
  const microdata = organizationMicroData({
    type: "Organization",
    address: {
      addressCountry: "CA",
      addressRegion: "QC",
      addressLocality: "Sainte-Catherine",
      postalCode: "H3B 1A6",
      streetAddress: "486 Sainte-Catherine St. W, Suite#200",
    },
    department: [
      {
        "@type": "store",
        name: "PartsAvatar Calgary",
        address: {
          "@type": "PostalAddress",
          streetAddress: "3E-2320 35 AVE NE",
          addressLocality: "Calgary",
          addressRegion: "AB",
          postalCode: "T2E 6S9",
          addressCountry: "CA",
        },
        geo: {
          "@type": "GeoCoordinates",
          latitude: "51.084100",
          longitude: "-114.006580",
        },
        image: "https://partsavatar.ca/images/common/header-logo_16051144.png",
        openingHoursSpecification: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
          ],
          opens: "10 AM",
          closes: "4:30 PM",
        },
      },
      {
        "@type": "store",
        name: "PartsAvatar Mississauga",
        address: {
          "@type": "PostalAddress",
          streetAddress: "6127 Shawson Dr",
          addressLocality: "Mississauga",
          addressRegion: "ON",
          postalCode: "L5T 1E4",
          addressCountry: "CA",
        },
        geo: {
          "@type": "GeoCoordinates",
          latitude: "43.6518425986345",
          longitude: "-79.65712818895702",
        },
        image: "https://partsavatar.ca/images/common/header-logo_16051144.png",
        openingHoursSpecification: [
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
            ],
            opens: "9 AM",
            closes: "6 PM",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: [
              "Saturday",
            ],
            opens: "9 AM",
            closes: "6 PM",
          },
        ],
      },
    ],
    email: "customerservice@partsavatar.ca",
    faxNumber: "+1-844-850-5332",
    logo: "https://partsavatar.ca/images/common/header-logo_16051144.png",
  });

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(microdata) }}
      />
    </Head>

  );
}

export default OrganizationMetaHeader;
